import React, { useEffect, useState } from 'react';
import ApiHelper from 'src/utils/api/api_helper';
import { ImgPopup } from 'src/reusable/index';

const Image = (props) => {
  
  const appUrl = `${process.env.REACT_APP_API_HOST}`;
  const { bnrNo, fileNm, date } = {...props};

  return (
    fileNm !== '' &&
    <img 
      src={`${appUrl}ezp2/comm/bnr/getImages/bnr?fileNm=${fileNm}&now=${date}&bnrNo=${bnrNo}`}
      alt="광고" 
      className="banner" 
    />
  );
}

const Banner = (props) => {
  const { corpNo, memNo, top, bottom } = {...props};
  const appUrl = `${process.env.REACT_APP_API_HOST}`;
  const params = { corpNo, memNo };

  const [showPopup, setShowPopup] = useState(false);
  const [fileInfo, setFileInfo] = useState({
    bnrNo: '',
    realFileNm: '',
    date: '',
    urlInfo: '',
    dtlRealFileNm: '',
  });

  useEffect(async() =>{
    // let copyFileInfo = Object.assign({}, fileInfo);
    
    await ApiHelper.request(ApiHelper.methods.get, `/ezp2/comm/bnr/file-info`, params)
    .then((res) => {
      return res.data;
    }).then((data) => {
      const resData = data.data;
       setFileInfo({
        bnrNo: resData.BNR_NO,
        realFileNm: resData.REAL_FILE_NM,
        date: resData.DATE,
        urlInfo: resData.URL_INFO,
        title : resData.BNR_TITL,
        dtlRealFileNm: resData.DTL_REAL_FILE_NM,
       });
    }).catch((err) => {
      console.error(err);
    });
    
  }, []);

  function handleDtlView() {
    const { bnrNo, urlInfo, dtlRealFileNm } = fileInfo;

    if(urlInfo === ''){
      openPopup();
    } 
    /* 개발 테스트 코드 */
    // if(dtlRealFileNm === '') location.href = urlInfo;
    /* 운영반영 코드 */
    if(dtlRealFileNm === '') window.ReactNativeWebView.postMessage(urlInfo);

    params.bnrNo = bnrNo;

    ApiHelper.request(ApiHelper.methods.post, `/ezp2/comm/bnr/dtlView`, params)
    .then(() => { return; })
    .catch((err) => console.log(err));
  }

  function openPopup() {
    setShowPopup(true);
  }

  function closePopup() {
    setShowPopup(false);
  }

  

  return (
    <>
      {fileInfo.realFileNm !== '' && fileInfo.realFileNm !== undefined &&
        <div className="event-banner" onClick={handleDtlView}>
          {/* <img 
            src={`${appUrl}ezp2/comm/images/getImages/bnr?fileNm=${fileNm}`} 
            alt="광고" 
            className="banner" 
          /> */}
          {fileInfo.realFileNm !== '' &&
          <Image bnrNo={fileInfo.bnrNo} fileNm={fileInfo.realFileNm} date={fileInfo.date} />
        }
        </div>
      }
      {showPopup && <ImgPopup title={fileInfo.title} handleClosePopup={closePopup} dtlRealFileNm={fileInfo.dtlRealFileNm} />}
    </>
  )
};

export default React.memo(Banner);
